// SimpleBanner.jsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const SimpleBanner = () => {

  const bannerStyles = {
    banner: {
      backgroundImage: 'url("slider.png")',
      backgroundSize: 'cover',
  
      backgroundRepeat: 'no-repeat',
      padding: '100px 0',
      marginTop: '75px',
      color: '#ffffff',
      width: '100%',
    },

    content: {
      maxWidth: '700px'
    },

    legacyBox: {
      backgroundColor: 'rgba(255,255,255,0.15)',
      border: '1px solid #ffffff',
      borderRadius: '30px',
      padding: '8px 18px',
      display: 'inline-block',
      marginBottom: '20px',
      fontSize: '14px'
    },

    title: {
      fontSize: 'clamp(28px, 5vw, 48px)',
      fontWeight: '700',
      marginBottom: '10px',
      lineHeight: '1.2'
    },

    subtitle: {
      fontSize: 'clamp(18px, 3vw, 26px)',
      marginBottom: '15px',
      color: '#ffd27f'
    },

    location: {
      fontSize: 'clamp(14px, 2vw, 18px)',
      marginBottom: '25px'
    },

    quoteBox: {
      borderLeft: '4px solid #ffffff',
      padding: '15px 20px',
      backgroundColor: 'rgba(0,0,0,0.35)',
      borderRadius: '0 20px 20px 0',
      fontSize: 'clamp(14px, 2vw, 18px)',
      fontStyle: 'italic'
    }
  };

  return (
    <section style={bannerStyles.banner} id="home">
      <Container>
        <Row className="align-items-center">
          <Col lg={8} md={10} sm={12}>

            <div style={bannerStyles.content}>

              {/* Legacy Tag */}
              <div style={bannerStyles.legacyBox}>
                🪷 पौत्र: अमर स्वतंत्रता सेनानी पंडित भगवान दीन शर्मा जी
              </div>

              {/* Title */}
              <h1 style={bannerStyles.title}>
                पंडित धीरेंद्र कुमार शर्मा
              </h1>

              {/* Subtitle */}
              <h2 style={bannerStyles.subtitle}>
                सनातनी योद्धा एवं जनसेवक
              </h2>

              {/* Location */}
              <p style={bannerStyles.location}>
                144 विधानसभा, मोहम्मदी (खीरी)
              </p>

              {/* Quote */}
              <div style={bannerStyles.quoteBox}>
                "विरासत राष्ट्रभक्ति की, संकल्प जन-सेवा का — पंडित धीरेंद्र कुमार शर्मा, मोहम्मदी का अटूट विश्वास।"
              </div>

            </div>

          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SimpleBanner;